import type { MfaDetailsResponse } from '../../generated/api/mfaDetailsResponse.js';

export const isMfaAlreadyEnabled = (mfaDetails: MfaDetailsResponse) =>
  mfaDetails.saIds.length === 1 && mfaDetails.isMfaRequired && !mfaDetails.userRightsInSalesforce;

export const isMfaManagementAllowed = (mfaDetails: MfaDetailsResponse) =>
  mfaDetails.saIds.length === 1 && !mfaDetails.isMfaRequired && !mfaDetails.userRightsInSalesforce;
